import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://98e9346b81801289ff95895744c38641@o4509606542180352.ingest.us.sentry.io/4509644567085056",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: false,
  integrations: [
  ],
});
